import React from 'react';

import Container from '../../shared/Container';
import { ShsPricingTile } from './types/ShsPricingTile';
import ShsCard from './components/ShsCard';

export default function ShsPricing({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: ShsPricingTile;
  trackingPrefix?: string;
}>) {
  return (
    <Container className="overflow-visible">
      <div className=" grid grid-cols-1 gap-x-8 gap-y-6 pt-10 md:grid-cols-3">
        {tile.cards.chunks.map((card, index) => (
          <ShsCard
            key={card[0]?.id ?? `shs-card-${index}`}
            card={card}
            index={index}
            trackingPrefix={trackingPrefix}
          />
        ))}
      </div>
    </Container>
  );
}
